import { Component, OnInit } from '@angular/core';
// import { HeaderComponent } from '../header/header.component';
// import { HomescreenComponent } from '../homescreen/homescreen.component';
// import { AppRoutingModule } from '../../app-routing.module';
@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/homepage/homepage.component.ts